import React, { useEffect, useState } from "react";
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import { formatBookingDateForDisplay } from "../utils/formatBookingDate";
import { useNavigate } from "react-router-dom";
import "../CSS/Global.css";
import Header from "../Components/Header";
import CryptoJS from "crypto-js"; // For decryption
import orderimg from "../Images/noorder.jpg";

const NewOrder = () => {
  const [filter, setFilter] = useState("all-order");
  const [order, setOrder] = useState([]);
  const url = getApiBaseUrl()
  const navigate = useNavigate();
  const login = JSON.parse(localStorage.getItem("login")) || "";

  const decrypt = (encryptedData, iv) => {
    const key = "ThisIsA32CharacterLongKey123456!";

    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const ivHex = CryptoJS.enc.Hex.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Hex.parse(encryptedData) },
      keyHex,
      {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  const fetchOrderData = async () => {
    try {
      const response = await fetch(
        `${url}/pay-all/users/${login.permanent_ID}`
      );
      const res = await response.json();
      console.log(res)
      console.log(res.data.data)
      const decryptedData = decrypt(res.data.data, res.data.iv);
      console.log(decryptedData)
      if (decryptedData) {
        const parsedData = JSON.parse(decryptedData).map((order) => ({
          ...order,
          product: order.product ? (typeof order.product === 'string' ? JSON.parse(order.product) : order.product) : [],
          user_address: order.user_address ? (typeof order.user_address === 'string' ? JSON.parse(order.user_address) : order.user_address) : {},
          vendor_address: order.vendor_address ? (typeof order.vendor_address === 'string' ? JSON.parse(order.vendor_address) : order.vendor_address) : {},
        }));
        console.log(parsedData)
        setOrder(parsedData.reverse());
      } else {
        console.error("Decrypted data is empty or invalid");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const filteredOrders =
    filter === "all-order"
      ? order
      : order.filter((o) => (o.status || '').toLowerCase() === filter.toLowerCase());

  useEffect(() => {
    fetchOrderData();
  }, []);

  return (
    <>
      <Header />
      <div className="new-orders user-order-page">
        <div className="new-order-container user-order-container">
          <div className="user-order-header">
            <h1 className="user-order-title">Bookings</h1>
            <div className="order-dropdown user-order-filter">
              <select
                name="order-select"
                id="order-select"
                value={filter}
                onChange={handleFilterChange}
              >
                <option value="all-order">All Bookings / Projects</option>
                <option value="Pending">Pending</option>
                <option value="Dispatch">Dispatch</option>
                <option value="Out for Delivery">Out for Delivery</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
              </select>
            </div>
          </div>
          <div className="user-order-list">
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => {
                const bookedForLabel = formatBookingDateForDisplay(order.booking_date);
                return (
                <div className="user-order-card" key={order.transaction_id}>
                  <div className="user-order-card-header">
                    <div className="user-order-card-id">
                      <span className="user-order-card-label">Booking #</span>
                      <span className="user-order-card-value">{order.transaction_id}</span>
                    </div>
                    <div className="user-order-card-status">
                      <span className={`user-order-badge user-order-badge--${(order.status || 'pending').toLowerCase().replace(/\s+/g, '-')}`}>
                        {order.status ? order.status.charAt(0).toUpperCase() + order.status.slice(1) : 'Pending'}
                      </span>
                    </div>
                  </div>
                  <div className="user-order-card-dates">
                    <span className="user-order-date">
                      <i className="fa-regular fa-calendar"></i> Ordered: {new Date(order.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                    </span>
                    {bookedForLabel && (
                      <span className="user-order-date user-order-date--highlight">
                        <i className="fa-regular fa-calendar-check"></i> Booked for: {bookedForLabel}
                      </span>
                    )}
                  </div>
                  <div className="user-order-card-items">
                    <h4 className="user-order-items-title">Items</h4>
                    {(order.product || []).map((item, i) => (
                      <div key={i} className="user-order-item">
                        <div className="user-order-item-info">
                          <span className="user-order-item-name">{item.product?.product_name}</span>
                          <span className="user-order-item-meta">Qty: {item.quantity} × ₹{item.product?.sell_price?.toFixed(2) || '0.00'}</span>
                        </div>
                        <span className="user-order-item-price">₹{((item.quantity || 0) * (item.product?.sell_price || 0)).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                  <div className="user-order-card-footer">
                    <div className="user-order-card-customer">
                      <i className="fa-regular fa-user"></i>
                      <span>Booked by <strong>{order.user_address?.name || 'N/A'}</strong></span>
                    </div>
                    <div className="user-order-card-actions">
                      <div className="user-order-total">
                        <span className="user-order-total-label">Total</span>
                        <span className="user-order-total-amount">₹{(order.amount_p || 0).toFixed(2)}</span>
                      </div>
                      <div className="user-order-buttons">
                        <button
                          className="user-order-btn user-order-btn--primary"
                          onClick={() => navigate(`/track/${order.transaction_id}`)}
                        >
                          Track Order
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                );
              })
            ) : (
              <div className="user-order-empty">
                <img className="user-order-empty-img" src={orderimg} alt="No bookings or projects yet" />
                <p className="user-order-empty-text">No bookings or projects yet</p>
                <p className="user-order-empty-sub">Your booking history will appear here</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewOrder;
